import { ReactComponent as BtnPlay } from '@/assets/icons/btn_play.svg'
import Button from '@/components/common/Button'

const PreviewBanner = ({video}) => (
    <div className="relative h-[250px] w-[180px]">
        <img
            src={video.thumbnail_image}
            alt=""
            className="rounded overflow-hidden h-[250px] w-[180px] object-cover"
        />
        <Button
            className="absolute left-0 right-0 top-0 bottom-0"
            type="button"
            onClick={() => {
                const newWindow = window.open(video.src, '_blank', 'noopener,noreferrer')
                if (newWindow) newWindow.opener = null
            }}
            >
            <BtnPlay/>
        </Button>
    </div>
)

export default PreviewBanner
